module.exports = __webpack_public_path__ + "img/news_center_title.c261b7cd.png";